/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Goal_Deadline_PastInputs */

const en_us2_exercise_goal_deadline_past = /** @type {(inputs: Exercise_Goal_Deadline_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That date has passed. Choose a later one.`)
};

const pt_br2_exercise_goal_deadline_past = /** @type {(inputs: Exercise_Goal_Deadline_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa data já passou. Escolha uma data futura.`)
};

const es_419_exercise_goal_deadline_past = /** @type {(inputs: Exercise_Goal_Deadline_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa fecha ya pasó. Elige una posterior.`)
};

const pt_pt2_exercise_goal_deadline_past = /** @type {(inputs: Exercise_Goal_Deadline_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa data já passou. Escolhe uma data futura.`)
};

const fr_fr2_exercise_goal_deadline_past = /** @type {(inputs: Exercise_Goal_Deadline_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette date est passée. Choisis une date future.`)
};

const de_de2_exercise_goal_deadline_past = /** @type {(inputs: Exercise_Goal_Deadline_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Datum ist vorbei. Wähle ein späteres.`)
};

const it_it2_exercise_goal_deadline_past = /** @type {(inputs: Exercise_Goal_Deadline_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella data è già passata. Scegline una successiva.`)
};

/**
* | output |
* | --- |
* | "That date has passed. Choose a later one." |
*
* @param {Exercise_Goal_Deadline_PastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_goal_deadline_past = /** @type {((inputs?: Exercise_Goal_Deadline_PastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Goal_Deadline_PastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_goal_deadline_past(inputs)
	if (locale === "es-419") return es_419_exercise_goal_deadline_past(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_goal_deadline_past(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_goal_deadline_past(inputs)
	if (locale === "de-DE") return de_de2_exercise_goal_deadline_past(inputs)
	if (locale === "it-IT") return it_it2_exercise_goal_deadline_past(inputs)
	return en_us2_exercise_goal_deadline_past(inputs)
});
export { exercise_goal_deadline_past as "exercise_goal.deadline_past" }